import {
  GET_SEARCH_RESULTS,
  STACK_SEARCH_RESULTS,
  SEARCH_LOADER,
  RESET_SEARCH_RESULT,
  SAVE_HISTORY_STATE,
  GET_TOPIC_DATA,
  GET_SEARCH_SUGGESTIONS,
  GET_TOGGLE_DATA,
  ADD_SELECTED_ASSETS_PILLS_COLLECTION,
  GET_API_RESPONSE_STATUS,
  SET_CLIENT_DATA_TOGGLE,
  SET_CLEAR_SEARCH_TEXT,
  SET_CLEAR_SEARCH_REFINERS,
  STACK_SEARCH_SUGGESTIONS,
  SET_CLEAR_REFINERS,
} from '../../constants/reducerTypes';

const initialState = {
  searchResults: [],
  clientSearchResults: [],
  totalRows: 0,
  searchPage: 0,
  pageDetails: {
    itemCount: 0,
    mdwCount: 0,
    spCount: 0,
    mdwCurrentPage: 0,
    spCurrentPage: 0,
    mdwTotalPages: 0,
    spTotalPages: 0,
  },
  issearchResultsSuccess: true,
  isclientSearchResultsSuccess: true,
  searchLoader: true,
};
const searchResultsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: action.payload.results,
        clientSearchResults: action.payload.clientResults,
        totalRows: action.payload.totalRows,
        searchPage: 1,
        pageDetails: action.payload.pageDetails,
        issearchResultsSuccess: action.payload.issearchResultsSuccess,
        isclientSearchResultsSuccess: action.payload.isclientSearchResultsSuccess,
        isRequestSuccess: action.payload.isRequestSuccess,
        searchLoader: false,
      };
    case STACK_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: state.searchResults.concat(action.payload.results),
        clientSearchResults: state.clientSearchResults.concat(action.payload.clientResults),
        totalRows: action.payload.totalRows,
        searchPage: state.searchPage + 1,
        pageDetails: action.payload.pageDetails,
        issearchResultsSuccess: action.payload.issearchResultsSuccess,
        isclientSearchResultsSuccess: action.payload.isclientSearchResultsSuccess,
        isRequestSuccess: action.payload.isRequestSuccess,
        searchLoader: false,
      };
    case SEARCH_LOADER:
      return {
        ...state,
        searchLoader: true,
      };
    case SAVE_HISTORY_STATE:
      return {
        ...state,
        persistState: action.payload.previousState,
      };
    case RESET_SEARCH_RESULT:
      return {
        ...state,
        ...initialState,
      };
    case GET_TOPIC_DATA:
      return {
        ...state,
        topicCardData: action.payload,
      };
    case GET_SEARCH_SUGGESTIONS:
      return {
        ...state,
        searchSuggestionsData: action.payload,
      };
    case STACK_SEARCH_SUGGESTIONS:
      return {
        ...state,
        stackSearchSuggestionsData: action.payload,
      };
    case GET_TOGGLE_DATA:
      return {
        ...state,
        toggleData: action.payload,
      };
    case ADD_SELECTED_ASSETS_PILLS_COLLECTION:
      return {
        ...state,
        asstesPills: action.payload,
      };
    case GET_API_RESPONSE_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };
    case SET_CLIENT_DATA_TOGGLE:
      return {
        ...state,
        clientDataToggle: action.payload,
      };
    case SET_CLEAR_SEARCH_TEXT:
      return {
        ...state,
        clearSearchText: action.payload,
      };
    case SET_CLEAR_REFINERS:
      return {
        ...state,
        clearRefiners: action.payload,
      };
    case SET_CLEAR_SEARCH_REFINERS:
      return {
        ...state,
        clearSearchRefiners: action.payload,
      };
    default:
      return state;
  }
};
export default searchResultsReducer;
